const MAT_CHART_COLOR_WORDS = [
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
  "eleven",
  "twelve",
  "thirteen",
  "fourteen",
  "fifteen",
  "sixteen",
  "seventeen",
  "eighteen",
  "nineteen",
  "twenty",
  "twentyone",
  "twentytwo",
  "twentythree",
  "twentyfour",
  "twentyfive",
  "twentysix",
  "twentyseven",
  "twentyeight",
  "twentynine",
  "thirty",
  "thirtyone",
  "thirtytwo",
  "thirtythree",
  "thirtyfour",
  "thirtyfive",
  "thirtysix",
  "thirtyseven",
  "thirtyeight",
  "thirtynine",
  "forty",
] as const;

export const MAT_CHART_COLOR_COUNT = MAT_CHART_COLOR_WORDS.length;

/** Maps 1-based index to `--mat-charts-color-*` suffix (e.g. 1 → "one"). */
export function matChartColorWord(index: number): string {
  return MAT_CHART_COLOR_WORDS[index - 1] ?? "";
}

/** Resolves theme chart CSS variables in palette order (`--mat-charts-color-one` … `forty`). */
export function resolveMatChartColors(maxColors = MAT_CHART_COLOR_COUNT): string[] {
  if (typeof document === "undefined") {
    return [];
  }

  const root = getComputedStyle(document.documentElement);
  const limit = Math.min(maxColors, MAT_CHART_COLOR_COUNT);
  const colors: string[] = [];

  for (let i = 1; i <= limit; i += 1) {
    const word = matChartColorWord(i);
    if (!word) {
      break;
    }

    const color = root.getPropertyValue(`--mat-charts-color-${word}`).trim();
    if (color) {
      colors.push(color);
    }
  }

  return colors;
}
